import Hosts from '../../Hosts';

const object_type = 'intranet/quality'
const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
/*const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`*/
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/forms`

const base_endpoint = '/forms'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: [],
        title: [],
        description: [],

        date: '',
        time: '',
        location: '',
        prioridade: [],
        visibilidade: false,
        type: 'forms',
        event_type: '',

        image: {},
        color: {
            primary: '',
            primary_rgb: '',
            secondary: '',
        },
        order: 0,
        poll: [],       
        isLocked: false,
        avaiable: false,
    },
    createadBy: '',
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}